export function fromPattern(pattern: string) {
  const spaces = pattern.split(/{ *(\w+) *}/gi).slice(1, -1);
  const words: string[][] = [[]];
  const softHyphen = "\u00AD";
  let currentWord = 0;

  for (const segment of spaces) {
    if (segment === "") {
      words[currentWord]?.push(softHyphen);
      continue;
    }

    // Segment is a space. We should start a new word.
    if (segment.startsWith(" ")) {
      words.push([]);
      currentWord++;
      continue;
    }

    words[currentWord]?.push(segment);
  }

  return words;
}
